import Counter from "@/ui/core/Counter";
import Text from "@/ui/core/Text";
import type {
  UserTabSelectorProps,
  UserTabSelectorTabProps,
} from "@/ui/core/UserTabSelector";
import UserTabSelector from "@/ui/core/UserTabSelector";
import { Box } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface SectionHeaderProps extends BaseViewProps {
  appUserBadgeCount?: number;
  appUserId: string;
  initialUserId?: UserTabSelectorProps["initialUserId"];
  isAppUserSupport: boolean;
  isInlineHeader?: boolean;
  onUserChange: (userId: string) => void;
  title: string;
  userTabs?: UserTabSelectorTabProps[];
}

enum SectionHeaderDimensions {
  ScreenHeaderHeight = 70,
}

const SectionHeader = ({
  accessibilityLabel,
  appUserBadgeCount,
  appUserId,
  initialUserId,
  isAppUserSupport,
  isInlineHeader,
  onUserChange,
  testID,
  title,
  userTabs: tabs,
}: SectionHeaderProps) => {
  const baseTestID = joinTestIDs(testID, "section");

  const paddingHorizontal = isInlineHeader
    ? 0
    : LayoutToken.ContentPaddingHorizontal;

  return (
    <Box
      accessibilityLabel={accessibilityLabel}
      alignItems="center"
      flexDirection="row"
      gap={8}
      height={
        isInlineHeader ? "unset" : SectionHeaderDimensions.ScreenHeaderHeight
      }
      justifyContent={isAppUserSupport ? "space-between" : "flex-start"}
      paddingHorizontal={paddingHorizontal}
      testID={baseTestID}
      width="100%"
    >
      <Box flex={1}>
        <Text
          numberOfLines={1}
          testID={joinTestIDs(baseTestID, "title")}
          variant="h5"
        >
          {title}
        </Text>
      </Box>
      {isAppUserSupport && tabs ? (
        <UserTabSelector
          accessibilityLabel={accessibilityLabel}
          appUserId={appUserId}
          initialUserId={initialUserId}
          onUserChange={onUserChange}
          tabs={tabs}
          testID={baseTestID}
        />
      ) : (
        <Counter isActive number={appUserBadgeCount} testID={baseTestID} />
      )}
    </Box>
  );
};

export type { SectionHeaderProps };
export { SectionHeaderDimensions };
export default SectionHeader;
